import { useEffect, useRef } from "react";
import { classNames as cn } from "tools/ui";

function Popover({
  name,
  children,
  show,
  onDone,
  className,
  classNameContainer,
  trigger = "click",
  style,
}) {
  const wrapperRef = useRef(null);

  function onClickDone() {
    show.value = false;
    if (onDone) {
      onDone(name);
    }
  }

  function handleMouseLeft() {
    if (trigger === "hover") {
      show.value = false;
    } else {
      show.value = false;
    }
  }

  function handleClickOutside(event) {
    if (show.value || wrapperRef.current.contains(event.target)) {
      // Clicked inside div
      show.value = true;
    }
  }

  useEffect(() => {
    if (show.value) {
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [show, wrapperRef]);

  return (
    <div
      id={name}
      ref={wrapperRef}
      style={style}
      className={cn(
        "absolute h-fit z-50 transition-all overflow-visible",
        classNameContainer,
      )}
      onMouseEnter={() => (show.value = true)}
      onMouseLeave={handleMouseLeft}
      hidden={!show?.value}
    >
      <div
        className={cn("relative rounded-xl shadow-md p-2 bg-white", className)}
      >
        {onDone && (
          <button
            type="button"
            className="ml-auto bg-blue-900 text-white px-3 py-1 mb-2 rounded-md"
            onClick={onClickDone}
          >
            Ok
          </button>
        )}
        {children}
      </div>
    </div>
  );
}

export default Popover;
